/**
 * Enum for additional field names used in business entities
 */
export enum AdditionalFieldNames {
  PATH = 'path',
  IS_TEMPLATE = 'istemplate'
}

/**
 * Enum for additional field types
 */
export enum AdditionalFieldTypes {
  STRING = 'String',
  BOOLEAN = 'Boolean'
}

/**
 * Enum for additional field labels
 */
export enum AdditionalFieldLabels {
  PATH = 'Path',
  IS_TEMPLATE = 'Is Template'
}
